import React from 'react'

import { GroupCreateContainer } from '@/components/containers/standardization/groups/GroupCreateContainer'

const CreateGroupPage: React.FC = () => <GroupCreateContainer />

export default CreateGroupPage
